import { render } from "./UploadDocument.vue?vue&type=template&id=4f4bfe23&scoped=true"
import script from "./UploadDocument.vue?vue&type=script&lang=js"
export * from "./UploadDocument.vue?vue&type=script&lang=js"

import "./UploadDocument.vue?vue&type=style&index=0&id=4f4bfe23&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4bfe23"]])

export default __exports__